import { defineComponent as _defineComponent } from 'vue'

const __default__ = {
	inheritAttrs: false,
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'ItemListaDetalhes',
  props: {
	icone: { default: undefined, type: String },
	titulo: { default: undefined, type: [String, Number] },
	subtitulo: { default: undefined, type: [String, Number] },
	href: { default: undefined, type: String },
},
  setup(__props) {



return { __sfc: true, }
}

})